import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { auth } from "../../firebase";
import { FirebaseService } from "../../services/firebase.service";
import { validateEmail } from "../../utils/utils";
import "./Register.scss";

const xidWhiteLogo = require("../../assets/white-logo.png");

export const Register = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [user, loading] = useAuthState(auth);
  const [isMobile, setIsMobile] = useState(false);
  const [registering, setRegistering] = useState(false);
  const navigate = useNavigate();

  const register = async () => {
    try {
      setRegistering(true);
      const result = await FirebaseService.registerWithEmailAndPassword(
        username,
        email,
        password
      );
      if (result) {
        navigate("/personas");
      }
    } catch (e) {}
  };

  const handleResize = () => {
    if (window.innerWidth <= 1200) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
  });

  useEffect(() => {
    if (loading) return;

    if (user && !registering) navigate("/");
  }, [user, loading]);

  const validatePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    const confirmPassword = e.target.value;

    if (password !== confirmPassword) {
      setConfirmPassword("");
      e.target.setCustomValidity("Passwords do not match");
      document.getElementById("confirm-password")?.classList.add("invalid");
    } else {
      e.target.setCustomValidity("");
      setConfirmPassword(confirmPassword);
      document.getElementById("confirm-password")?.classList.remove("invalid");
    }
  };

  return (
    <div
      className={`row register-page page-wrapper ${
        !isMobile ? "desktop-background-image" : ""
      }`}
    >
      <div className="col m4">
        {!isMobile ? (
          <Header logoColor="black" />
        ) : (
          <>
            <div className="mobile-header">
              <img src={xidWhiteLogo}></img>
            </div>
            <span className="text-main">
              Earn points that you can redeem <br />
              by creating a secure xID profile.
            </span>
          </>
        )}
      </div>
      <div className="col m4 section-wrapper">
        <div className="auth-form">
          <div className="input-field">
            <input
              id="username"
              type="text"
              className="validate"
              onChange={(event) => setUsername(event.target.value)}
              required
            />
            <i className="material-icons icon">check</i>
            <label htmlFor="username">Select a Username</label>
            <span className="helper-text" data-error="Required"></span>
          </div>
          <div className="input-field">
            <input
              id="email"
              type="email"
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              className="validate"
              onChange={(e) => {
                const email = e.target.value;
                const isValid = validateEmail(email);

                isValid ? setEmail(email) : setEmail("");
              }}
            />
            <i className="material-icons icon">check</i>
            <label htmlFor="email">Your email</label>
            <span className="helper-text" data-error="Invalid Email"></span>
          </div>
          <div className="input-field">
            <input
              id="password"
              type="password"
              className="validate"
              onChange={(event) => setPassword(event.target.value)}
              required
            />
            <i className="material-icons icon">check</i>
            <label htmlFor="password">Password</label>
            <span className="helper-text" data-error="Required"></span>
          </div>
          <div className="input-field">
            <input
              id="confirm-password"
              type="password"
              className="validate"
              onChange={validatePassword}
              required
            />
            <i className="material-icons icon">check</i>
            <label htmlFor="confirm-password">Confirm password</label>
            <span
              className="helper-text"
              data-error="Passwords do not match"
            ></span>
          </div>
        </div>
      </div>
      <div className="col m4">
        <Button
          type="secondary"
          size="large"
          disabled={!username || !email || !password || !confirmPassword}
          onClick={register}
        >
          Submit
        </Button>
        {!isMobile && <Footer />}
      </div>
    </div>
  );
};
